import { Box, CircularProgress, Container, Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

let desc = '';
let lugarCentral = '';
let vinculacion = '';
let cargo = '';
let grado = '';
let escalafon = '';
let codRelLab = '';
let codForPago = '';
let serieConcurso = '';

class DatosFuncionarios extends Component{
    constructor(props){
        super(props);
        this.state = {
            errores: null,
            notificaciones: null,

            datos: {
                funcionarioBuscar: '',
                ci: '',
                primerNombre: '',
                segundoNombre: '',
                primerApellido: '',
                segundoApellido: '',
                fechaNacimiento: '',
            },

            loading: false,
            datosConsulta: [],
            consulta: false,
            modalConsulta: false,
            ingresoFuncionario: {},
            codRelaLaboral: [],
            vinculacion: [],
            codFormaPago: [],
            cargos: [],
            lugaresTrabajo: [],
            serieBase: [],
            departamentos: [],
            escalafones: [],
            ubicacionesCentral: [],
            codigosIngresos: [],
        }

        this.manejoEnvioNumeroFuncionario = this.manejoEnvioNumeroFuncionario.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarEdicion = this.manejarEdicion.bind(this);
        this.manejarAtrasConsulta = this.manejarAtrasConsulta.bind(this);
    }

    async componentDidMount(){
        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_codigosRelLab.php`);
        const datos = await respuesta.json();
        this.setState({
            codRelaLaboral: datos,
        });

        const vin = await fetch(`${Constantes.RUTA_API}/obtener_vinculaciones.php`);
        const dat = await vin.json();
        this.setState({
            vinculacion: dat,
        });

        const pago = await fetch(`${Constantes.RUTA_API}/obtener_formasPago.php`);
        const datPago = await pago.json();
        this.setState({
            codFormaPago: datPago,
        });

        const datosCargos = await fetch(`${Constantes.RUTA_API}/obtener_cargos.php`);
        const datoCargo = await datosCargos.json();
        this.setState({
            cargos: datoCargo,
        });

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTrabajo: datoLugar,
        });

        const serie = await fetch(`${Constantes.RUTA_API}/obtener_series.php`);
        const datoSerie = await serie.json();
        this.setState({
            serieBase: datoSerie,
        });

        const departamento = await fetch(`${Constantes.RUTA_API}/obtener_departamentos.php`);
        const datoDepartamento = await departamento.json();
        this.setState({
            departamentos: datoDepartamento,
        });

        const datosEscalafones = await fetch(`${Constantes.RUTA_API}/obtener_escalafones.php`);
        const datoEscalafon = await datosEscalafones.json();
        this.setState({
            escalafones: datoEscalafon,
        });

        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });

        const respuestaIngresos = await fetch(`${Constantes.RUTA_API}/obtener_codigosIngresos.php`);
        const datosIngresos = await respuestaIngresos.json();
        this.setState({
            codigosIngresos: datosIngresos,
        });
    }

    render(){
        return (
            <>
                <h3>Datos Funcionarios</h3>
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}

                <form className='formulario'  onSubmit={this.manejoEnvioNumeroFuncionario}>
                    <Box sx={{ flexGrow: 1}}>
                        <Grid container spacing={2} rowSpacing={1}>
                            <Grid item xs={1.5}>
                            </Grid>
                            <Grid item xs={3}>
                                Número de Funcionario
                            </Grid>
                            <Grid item xs={3}>
                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='funcionarioBuscar' value={this.state.datos.funcionarioBuscar} onChange={this.manejarCambiosDatos} type="text" />
                            </Grid>
                            <Grid item xs={1}>
                                <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                            </Grid>
                        </Grid>
                    </Box>
                </form>
                {(this.state.consulta) && (!this.state.modalConsulta)
                ?
                    <TableContainer style={{width: '90%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                        <Table sx={{minWidth: 700}} id="tablaConsulta">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Nº Funcionario</StyledTableCell>
                                    <StyledTableCell>P. Nombre</StyledTableCell>
                                    <StyledTableCell>S. Nombre</StyledTableCell>
                                    <StyledTableCell>P. Apellido</StyledTableCell>
                                    <StyledTableCell>S. Apellido</StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.datosConsulta.map((dat) => (
                                    <StyledTableRow key={dat.numeroFuncionario}>
                                        <StyledTableCell>{dat.numeroFuncionario}</StyledTableCell>
                                        <StyledTableCell>{dat.primerNombre}</StyledTableCell>
                                        <StyledTableCell>{dat.segundoNombre}</StyledTableCell>
                                        <StyledTableCell>{dat.primerApellido}</StyledTableCell>
                                        <StyledTableCell>{dat.segundoApellido}</StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-danger mx-2" onClick={() => this.manejarEdicion(dat)}>Consultar</button></StyledTableCell>
                                    </StyledTableRow>
                                ))
                                }
                            </TableBody>
                        </Table>
                        <br/>
                        <br/>
                    </TableContainer>
                :
                    null
                }
                {this.state.modalConsulta
                ?
                    <fieldset>
                        <legend>DATOS PERSONALES</legend>
                        <Box sx={{ flexGrow: 1}}>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2.1}>
                                    Primer Nombre <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <input label="sddddd" disabled={true} style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='primerNombre' value={this.state.ingresoFuncionario.primerNombre} onChange={this.manejarCambiosDatos}/>
                                </Grid>
                                <Grid item xs={2.1}>
                                    Segundo Nombre
                                </Grid>
                                <Grid item xs={3}>
                                    <input disabled={true} style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='segundoNombre' value={this.state.ingresoFuncionario.segundoNombre} onChange={this.manejarCambiosDatos}/>
                                </Grid>
                                <Grid item xs={2.1}>
                                    Primer Apellido <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <input disabled={true} style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='primerApellido' value={this.state.ingresoFuncionario.primerApellido} onChange={this.manejarCambiosDatos} />
                                </Grid>
                                <Grid item xs={2.1}>
                                    Segundo Apellido
                                </Grid>
                                <Grid item xs={3}>
                                    <input disabled={true} style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='segundoApellido' value={this.state.ingresoFuncionario.segundoApellido} onChange={this.manejarCambiosDatos} />
                                </Grid>
                                <Grid item xs={2.1}>
                                    C.I. (SIN PUNTOS NI GUIONES) <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <input disabled={true} style={{border: "2px solid #D6EAF8", width: "100%"}} type="text" id='ci' value={this.state.ingresoFuncionario.ci} onChange={this.manejarCambiosDatos} />
                                </Grid>
                                <Grid item xs={2.1}>
                                    Fecha Nacimiento <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <input disabled={true} min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} type="date" id='fechaNacimiento' value={this.state.ingresoFuncionario.fechaNacimiento} onChange={this.manejarCambiosDatos}/>
                                </Grid>
                                <Grid item xs={2.1}>
                                    Credencial <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <input disabled={true} style={{border: "2px solid #D6EAF8", width: "40%", float: 'left'}} id='credencialSerie' type="text" placeholder='SERIE' value={this.state.ingresoFuncionario.credencialSerie} onChange={this.manejarCambiosDatos}/><input style={{border: "2px solid #D6EAF8", width: "60%"}} type="number" placeholder='NUMERO' id='credencialNumero' value={this.state.ingresoFuncionario.credencialNumero} onChange={this.manejarCambiosDatos}/>
                                </Grid>
                                <Grid item xs={6.9}>
                                    {/*Estolo pongo para un salto de linea */}
                                </Grid>
                                <Grid item xs={2.1}>
                                    Direccion <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={8.1}>
                                    <input disabled={true} style={{border: "2px solid #D6EAF8", width: "40%", float: 'left'}} type="text" id='direccionCalle' placeholder='CALLE' value={this.state.ingresoFuncionario.direccionCalle} onChange={this.manejarCambiosDatos}/>
                                    <input disabled={true} style={{border: "2px solid #D6EAF8", width: "20%", float: 'left'}} type="number" id='direccionNumero' placeholder='NUMERO' value={this.state.ingresoFuncionario.direccionNumero} onChange={this.manejarCambiosDatos}/>
                                    <input disabled={true} style={{border: "2px solid #D6EAF8", width: "20%", float: 'left'}} type="text" id='direccionLocalidad' placeholder='LOCALIDAD' value={this.state.ingresoFuncionario.direccionLocalidad} onChange={this.manejarCambiosDatos}/>
                                    <select disabled={true} style={{width:"20%", border:"2px solid #D6EAF8"}} id='direccionDepartamento' value={this.state.ingresoFuncionario.direccionDepartamento} onChange={this.manejarCambiosDatos} >
                                        <option value=''></option>
                                        <option value='0'></option>
                                        {this.state.departamentos.map((name) =>
                                            <option
                                            key={name.idDepartamentos}
                                            value={name.idDepartamentos}
                                            >{name.descripcion}</option>
                                            )}
                                    </select>
                                </Grid>
                                <Grid item xs={2.1}>
                                    Teléfono
                                </Grid>
                                <Grid item xs={3}>
                                    <input disabled={true} style={{border: "2px solid #D6EAF8", width: "100%"}} type="number" id='telefono' value={this.state.ingresoFuncionario.telefono} onChange={this.manejarCambiosDatos}/>
                                </Grid>
                                <Grid item xs={2.1}>
                                    Celular <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <input disabled={true} style={{border: "2px solid #D6EAF8", width: "100%"}} type="number" id='celular' value={this.state.ingresoFuncionario.celular} onChange={this.manejarCambiosDatos}/>
                                </Grid>
                                <Grid item xs={2.1}>
                                    Carné De Salud <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <input disabled={true} min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} type="date" id='carneSalud' value={this.state.ingresoFuncionario.carneSalud} onChange={this.manejarCambiosDatos}/>
                                </Grid>
                                <Grid item xs={2.1}>
                                    Sexo <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <select disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}} id='sexo' value={this.state.ingresoFuncionario.sexo} onChange={this.manejarCambiosDatos}>
                                        <option value={''}>SEXO</option>
                                        <option value={0}>MASCULINO</option>
                                        <option value={1}>FEMENINO</option>
                                    </select>
                                </Grid>
                                <Grid item xs={2.1}>
                                    Ingreso a Institución <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <input disabled={true} min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='ingresoInstitucion' value={this.state.ingresoFuncionario.ingresoInstitucion} onChange={this.manejarCambiosDatos}/>
                                </Grid>
                                <Grid item xs={2.1}>
                                    Mecanismo de Ingreso <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <select disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigoIngreso' value={this.state.ingresoFuncionario.codigoIngreso || ''} onChange={this.manejarCambiosDatos}>
                                        <option value={''}></option>
                                        {this.state.codigosIngresos.map((name) =>
                                        <option
                                        key={name.idCodigoIngreso}
                                        value={name.idCodigoIngreso}
                                        >{name.descripcion}</option>
                                        )}
                                    </select>
                                </Grid>
                                <Grid item xs={2.1}>
                                    Puntaje <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                {["0", "1", "2", "3", "4", "5"].includes(String(this.state.ingresoFuncionario.codigoIngreso))
                                ?
                                    <Grid item xs={3}>
                                        <input disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='puntajeConcurso' value={this.state.ingresoFuncionario.puntajeConcurso} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                :
                                    <Grid item xs={3}>

                                    </Grid>
                                }
                                <Grid item xs={2.1}>
                                    Lugar Ordenamiento <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                {["0", "1", "2", "3", "4", "5"].includes(String(this.state.ingresoFuncionario.codigoIngreso))
                                ?
                                    <Grid item xs={3}>
                                        <input disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='lugarOrdenamiento' value={this.state.ingresoFuncionario.lugarOrdenamiento} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                :
                                    <Grid item xs={3}>
                                    </Grid>
                                }
                                <Grid item xs={2.1}>
                                    Vinculación <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <select disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}} id='vinculacion' value={this.state.ingresoFuncionario.vinculacion} onChange={this.manejarCambiosDatos} >
                                        <option value={''}>VINCULACION</option>
                                        {this.state.vinculacion.map((name) =>
                                            <option
                                            key={name.idVinculacion}
                                            value={name.idVinculacion}
                                            >{name.descripcion}</option>
                                            )}
                                    </select>
                                </Grid>
                                <Grid item xs={2.1}>
                                    Antigüedad
                                </Grid>
                                <Grid item xs={3}>
                                    <input disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='antiguedad' value={this.state.ingresoFuncionario.antiguedad} onChange={this.manejarCambiosDatos}/>
                                </Grid>
                            </Grid>
                        </Box>
                    </fieldset>
                :
                    null
                }
                {this.state.modalConsulta
                ?
                    <fieldset>
                        <legend>FORMACION ACADEMICA</legend>
                        {this.state.ingresoFuncionario.conFormacion
                        ?
                            <Box sx={{ flexGrow: 1}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2.1}>
                                        Título Universitario
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='tituloUniversitario1' value={this.state.ingresoFuncionario.tituloUniversitario1} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Fecha De Expedido
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='fechaExpedidoTitulo1' value={this.state.ingresoFuncionario.fechaExpedidoTitulo1} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Maestría
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='maestria1' value={this.state.ingresoFuncionario.maestria1} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Fecha De Expedido
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='fechaExpedidaMaestria1' value={this.state.ingresoFuncionario.fechaExpedidaMaestria1} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Postgrado
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='postgrado1' value={this.state.ingresoFuncionario.postgrado1} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Fecha De Expedido
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='fechaExpedidoPostgrado1' value={this.state.ingresoFuncionario.fechaExpedidoPostgrado1} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Título Universitario
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='tituloUniversitario2' value={this.state.ingresoFuncionario.tituloUniversitario2} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        FECHA DE EXPEDIDO
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='fechaExpedidoTitulo2' value={this.state.ingresoFuncionario.fechaExpedidoTitulo2} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Maestría
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='maestria2' value={this.state.ingresoFuncionario.maestria2} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        FECHA DE EXPEDIDO
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='fechaExpedidaMaestria2' value={this.state.ingresoFuncionario.fechaExpedidaMaestria2} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Postgrado
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='postgrado2' value={this.state.ingresoFuncionario.postgrado2} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        FECHA DE EXPEDIDO
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='fechaExpedidoPostgrado2' value={this.state.ingresoFuncionario.fechaExpedidoPostgrado2} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Título Universitario
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='tituloUniversitario3' value={this.state.ingresoFuncionario.tituloUniversitario3} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        FECHA DE EXPEDIDO
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='fechaExpedidoTitulo3' value={this.state.ingresoFuncionario.fechaExpedidoTitulo3} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Maestría
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='maestria3' value={this.state.ingresoFuncionario.maestria3} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        FECHA DE EXPEDIDO
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='fechaExpedidaMaestria3' value={this.state.ingresoFuncionario.fechaExpedidaMaestria3} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        Postgrado
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='postgrado3' value={this.state.ingresoFuncionario.postgrado3} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                    <Grid item xs={2.1}>
                                        FECHA DE EXPEDIDO
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='postgrado3' value={this.state.ingresoFuncionario.postgrado3} onChange={this.manejarCambiosDatos}/>
                                    </Grid>
                                </Grid>
                            </Box>
                        :
                            null
                        }
                    </fieldset>
                :
                    null
                }
                {this.state.modalConsulta
                ?
                    <fieldset>
                        <legend>DATOS FUNCIONARIOS</legend>
                        <Box sx={{ flexGrow: 1}}>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2.14}>
                                    Código Relación Laboral <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <select disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigoRelLaboral' value={this.state.ingresoFuncionario.codigoRelLaboral} onChange={this.manejarCambiosDatos}>
                                        <option value={''}></option>
                                        {this.state.codRelaLaboral.map((name) =>
                                        <option
                                        key={name.idCodigoRelacionLaboral}
                                        value={name.idCodigoRelacionLaboral}
                                        >{name.descripcion}</option>
                                        )}
                                    </select>
                                </Grid>
                                <Grid item xs={2.1}>
                                    Código Forma De Pago <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <select disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigoForPago' value={this.state.ingresoFuncionario.codigoForPago} onChange={this.manejarCambiosDatos}>
                                    <option value={''}></option>
                                        {this.state.codFormaPago.map((name) =>
                                        <option
                                        key={name.idCodigoFormaPago}
                                        value={name.idCodigoFormaPago}
                                        >{name.descripcion}</option>
                                        )}
                                        </select>
                                </Grid>
                                <Grid item xs={2.1}>
                                    Cargo <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <select disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}} id='cargo'  value={this.state.ingresoFuncionario.cargo} onChange={this.manejarCambiosDatos}>
                                        <option value=''>CARGOS</option>
                                        {this.state.cargos.map((name) =>
                                            <option
                                            key={name.idCargo}
                                            value={name.idCargo}
                                            >{name.descripcion}</option>
                                            )}
                                    </select>
                                </Grid>
                                <Grid item xs={2.1}>
                                    Escalafón <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <select disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}} id='escalafon'  value={this.state.ingresoFuncionario.escalafon} onChange={this.manejarCambiosDatos}>
                                        <option value=''>ESCALAFON</option>
                                        {this.state.escalafones.map((name) =>
                                            <option
                                            key={name.idEscalafon}
                                            value={name.idEscalafon}
                                            >{name.descripcion}</option>
                                            )}
                                    </select>
                                </Grid>
                                <Grid item xs={2.1}>
                                    Grado <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <select disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}} id='grado' value={this.state.ingresoFuncionario.grado} onChange={this.manejarCambiosDatos}>
                                        <option value={''}></option>
                                        <option value={1}>1</option>
                                        <option value={2}>2</option>
                                        <option value={3}>3</option>
                                        <option value={4}>4</option>
                                        <option value={5}>5</option>
                                        <option value={6}>6</option>
                                        <option value={7}>7</option>
                                        <option value={8}>8</option>
                                        <option value={9}>9</option>
                                        <option value={10}>10</option>
                                        <option value={11}>11</option>
                                        <option value={12}>12</option>
                                        <option value={13}>13</option>
                                        <option value={14}>14</option>
                                        <option value={15}>15</option>
                                        <option value={16}>16</option>
                                        </select>
                                </Grid>
                                <Grid item xs={2.1}>
                                    Serie Concurso<p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <select disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}} id='serieConcurso' value={this.state.ingresoFuncionario.serieConcurso} onChange={this.manejarCambiosDatos} >
                                        <option value={''}></option>
                                        {this.state.serieBase.map((name) =>
                                            <option
                                            key={name.idSerie}
                                            value={name.idSerie}
                                            >{name.descripcion}</option>
                                        )}
                                    </select>
                                </Grid>
                                <Grid item xs={2.1}>
                                    Carga Horaria <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <input disabled={true} style={{width:"50%", border:"2px solid #D6EAF8", float:"left"}} type="number" id='cargaHorariaHora' placeholder='HORAS' value={this.state.ingresoFuncionario.cargaHorariaHora} onChange={this.manejarCambiosDatos}/>
                                </Grid>
                                <Grid item xs={2.1}>
                                    Lugar <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <select disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}}  id="lugar" value={this.state.ingresoFuncionario.lugar} onChange={this.manejarCambiosDatos}>
                                        <option value={''}>LUGAR</option>
                                        {this.state.lugaresTrabajo.map((name) =>
                                            <option
                                            key={name.idLugaresTrabajo}
                                            value={name.idLugaresTrabajo}
                                            >{name.lugar}</option>
                                            )}
                                    </select>
                                </Grid>
                                {this.state.ingresoFuncionario.lugar == '0' ?
                                    <Grid item xs={2.1} >
                                        Lugar CENTRAL<p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.ingresoFuncionario.lugar == '0'
                                ?
                                    <Grid item xs={3}>
                                        <select disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}}  id="lugarCentral" value={this.state.ingresoFuncionario.lugarCentral} onChange={this.manejarCambiosDatos}>
                                            <option value={''}></option>
                                            {this.state.ubicacionesCentral.map((name) =>
                                                <option
                                                key={name.idUbicacionesCentral}
                                                value={name.idUbicacionesCentral}
                                                >{name.descripcion}</option>
                                                )}
                                        </select>
                                    </Grid>
                                :
                                    null
                                }
                                <Grid item xs={2.1}>
                                    Regimen Medicos Interior<p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p>
                                </Grid>
                                <Grid item xs={3}>
                                        <select disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}} id='regimenMedicos' value={this.state.ingresoFuncionario.regimenMedicos} onChange={this.manejarCambiosDatos}>
                                            <option value={''}>REGIMEN</option>
                                            <option value={0}>NO</option>
                                            <option value={1}>SI</option>
                                        </select>
                                </Grid>
                            </Grid>
                        </Box>
                    </fieldset>
                :
                    null
                }
                {this.state.modalConsulta
                ?
                    <button className="btn btn-outline-success mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasConsulta}>Volver</button>
                :
                    null
                }
            </>
        )
    }

    async manejoEnvioNumeroFuncionario(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            loading: true,
            datosConsulta: [],
        })
        const cargaUtil = JSON.stringify([this.state.datos]);
        const respuesta = await fetch(`${Constantes.RUTA_API}/consultar_Funcionario.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();

        this.setState({
            loading: false,
        })
        if(exito[0] !== 0){
            this.setState({
                datosConsulta: exito[1],
                consulta: true,
            })
        }
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
        });
        this.setState(state => {
            const funcionarioActualizado = state.datos;
            funcionarioActualizado[clave] = valor;
            return{
                datos: funcionarioActualizado,
            };
        })
    }

    async manejarEdicion(dato){

        this.setState({
            errores: null,
            notificaciones: null,
            loading: true,
        })

        const cargaUtil = JSON.stringify(dato);
        const respuesta = await fetch(`${Constantes.RUTA_API}/consultar_NumFun.php`,{
            method: 'POST',
            body: cargaUtil,
        })

        const exito = await respuesta.json();
        this.setState({
            notificaciones: null,
            loading: false,
        });

        this.setState({
            modalConsulta: true,
            ingresoFuncionario: exito[0],
        })
    }

    manejarAtrasConsulta(e){
        this.setState({
            errores: null,
            notificaciones: null,
            modalConsulta: false,
            ingresoFuncionario: {},
        })
    }
}

export default DatosFuncionarios